import React, { useState } from "react";
import { removePageContentFile } from "../../helper/apicalls/course";
import DeleteConfirmPopUp from "./deleteConfirmPopUp";
import Cookies from "js-cookie";

const MaterialViewer = ({
  material,
  onRemove,
  pageData,
  courseKey,
  subjectKey,
  topicKey,
  subTopicKey,
  title,
}) => {
  const role = Cookies.get("role");
  const [imageError, setImageError] = useState(false);
  const [audioError, setAudioError] = useState(false);
  const [pptViewer, setPptViewer] = useState("office");
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState(null);
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async (contentId) => {
    setSelectedContentId(contentId);
    setIsConfirmDeleteOpen(true);
  };

  const handleConfirmRemove = async () => {
    if (!selectedContentId) return;

    try {
      setIsRemoving(true);
      let contextKey = "";
      if (subTopicKey) {
        contextKey = subTopicKey;
      } else if (topicKey) {
        contextKey = topicKey;
      } else if (subjectKey) {
        contextKey = subjectKey;
      } else if (courseKey) {
        contextKey = courseKey;
      }

      const payload = {
        title: pageData?.title || title,
        key: contextKey || pageData?.key || "",
        pageid: pageData?.id || "",
        materils_id: selectedContentId,
      };

      await removePageContentFile(payload);

      // if (onRemove) {
      //   fetchPages();
      // }
    } catch (error) {
      console.error("Error removing content:", error);
    } finally {
      setIsRemoving(false);
      setIsConfirmDeleteOpen(false);
      setSelectedContentId(null);
    }
  };

  const handleCancelRemove = () => {
    setIsConfirmDeleteOpen(false);
    setSelectedContentId(null);
  };

  if (!material) return null;

  let type, link, name;
  let contentItems = [];

  if (
    material.content &&
    Array.isArray(material.content) &&
    material.content.length > 0
  ) {
    contentItems = material.content.map((item) => ({
      type:
        item.type || material.material_type || material.materials_type || "",
      link: item.content || "",
      id: item.id || "",
      sequence: item.sequence || 0,
      name: item.name,
    }));

    const firstItem = contentItems[0];
    type = firstItem.type;
    link = firstItem.link;
    name = material.name || "";
  } else if (material.content && material.content.length > 0) {
    type = (
      material.materials_type ||
      material.material_type ||
      ""
    ).toLowerCase();
    link = material.content || "";
    name = material.name || "";
    contentItems = [{ type, link, id: "", sequence: 0 }];
  } else {
    type = (
      material.materials_type ||
      material.material_type ||
      ""
    ).toLowerCase();
    link = "";
    name = material.name || "";
    contentItems = [];
  }

  type = type.toLowerCase();

  const isBlobUrl = typeof link === "string" && link.startsWith("blob:");

  const isVideo = type === "video" || type === "videos";
  const isPdf = type === "pdf";
  const isAudio = type === "audio" || type === "audios";
  const isImage = type === "image" || type === "images";
  const isPpt = type === "ppt" || type === "pptx" || type === "presentation";

  const isYouTubeLink =
    typeof link === "string" &&
    (link.includes("youtube.com") || link.includes("youtu.be"));

  const getDrivePreviewUrl = (rawUrl) => {
    if (typeof rawUrl !== "string" || !rawUrl) return null;
    try {
      const url = new URL(rawUrl);
      const host = url.hostname || "";

      const isDriveHost = host.includes("drive.google.com");
      const isDocsHost = host.includes("docs.google.com");
      if (!isDriveHost && !isDocsHost) return null;

      let id = url.searchParams.get("id");
      if (!id) {
        const match = url.pathname.match(/\/d\/([^/]+)/);
        if (match && match[1]) id = match[1];
      }
      if (!id) return null;

      if (isDocsHost) {
        const typeMatch = url.pathname.match(
          /^\/(document|presentation|spreadsheets|forms)\/d\//,
        );
        const docType = typeMatch ? typeMatch[1] : null;
        if (docType) {
          return `https://docs.google.com/${docType}/d/${id}/preview`;
        }
      }

      return `https://drive.google.com/file/d/${id}/preview`;
    } catch (e) {
      return null;
    }
  };

  const drivePreviewUrl = getDrivePreviewUrl(link);

  let youtubeEmbedUrl = null;
  if (isYouTubeLink) {
    try {
      if (link.includes("youtube.com/watch")) {
        const url = new URL(link);
        const v = url.searchParams.get("v");
        if (v) {
          youtubeEmbedUrl = `https://www.youtube.com/embed/${v}`;
        }
      } else if (link.includes("youtu.be/")) {
        const id = link.split("youtu.be/")[1]?.split(/[?&#]/)[0];
        if (id) {
          youtubeEmbedUrl = `https://www.youtube.com/embed/${id}`;
        }
      }
    } catch (e) {
      youtubeEmbedUrl = null;
    }
  }

  const renderContentItem = (item, index) => {
    const itemType = item.type.toLowerCase();
    const itemLink = item.link || null;
    const itemName = item.name;

    const isVideo = itemType === "video" || itemType === "videos";
    const isPdf = itemType === "pdf";
    const isAudio = itemType === "audio" || itemType === "audios";
    const isImage = itemType === "image" || itemType === "images";
    const isPpt =
      itemType === "ppt" || itemType === "pptx" || itemType === "presentation";

    const isYouTubeLink =
      typeof itemLink === "string" &&
      (itemLink.includes("youtube.com") || itemLink.includes("youtu.be"));

    const getDrivePreviewUrl = (rawUrl) => {
      if (typeof rawUrl !== "string" || !rawUrl) return null;
      try {
        const url = new URL(rawUrl);
        const host = url.hostname || "";

        const isDriveHost = host.includes("drive.google.com");
        const isDocsHost = host.includes("docs.google.com");
        if (!isDriveHost && !isDocsHost) return null;

        let id = url.searchParams.get("id");
        if (!id) {
          const match = url.pathname.match(/\/d\/([^/]+)/);
          if (match && match[1]) id = match[1];
        }
        if (!id) return null;

        if (isDocsHost) {
          const typeMatch = url.pathname.match(
            /^\/(document|presentation|spreadsheets|forms)\/d\//,
          );
          const docType = typeMatch ? typeMatch[1] : null;
          if (docType) {
            return `https://docs.google.com/${docType}/d/${id}/preview`;
          }
        }

        return `https://drive.google.com/file/d/${id}/preview`;
      } catch (e) {
        return null;
      }
    };

    const drivePreviewUrl = getDrivePreviewUrl(itemLink);

    let youtubeEmbedUrl = null;
    if (isYouTubeLink) {
      try {
        if (itemLink.includes("youtube.com/watch")) {
          const url = new URL(itemLink);
          const v = url.searchParams.get("v");
          if (v) {
            youtubeEmbedUrl = `https://www.youtube.com/embed/${v}`;
          }
        } else if (itemLink.includes("youtu.be/")) {
          const id = itemLink.split("youtu.be/")[1]?.split(/[?&#]/)[0];
          if (id) {
            youtubeEmbedUrl = `https://www.youtube.com/embed/${id}`;
          }
        }
      } catch (e) {
        youtubeEmbedUrl = null;
      }
    }

    return (
      <div key={item.id || index} className="content-item">
        {(contentItems.length > 1 || itemType === "audio") && (
          <h4
            style={{
              marginBottom: "10px",
              fontSize: "14px",
              fontWeight: "600",
              textTransform: "capitalize",
            }}
          >
            {itemName || (itemType === "audio" ? material.name : "")}
          </h4>
        )}

        {isVideo && itemLink && youtubeEmbedUrl && (
          <iframe
            title={itemName || "Video"}
            src={youtubeEmbedUrl}
            style={{
              width: "100%",
              height: contentItems.length > 1 ? "300px" : "70vh",
              border: "none",
              borderRadius: "8px",
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}

        {isVideo && itemLink && !youtubeEmbedUrl && drivePreviewUrl && (
          <iframe
            title={itemName || "Video"}
            src={drivePreviewUrl}
            style={{
              width: "100%",
              height: contentItems.length > 1 ? "300px" : "70vh",
              border: "none",
              borderRadius: "8px",
            }}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}

        {isVideo && itemLink && !youtubeEmbedUrl && !drivePreviewUrl && (
          <video
            controls
            style={{
              width: "100%",
              maxHeight: contentItems.length > 1 ? "300px" : "70vh",
              borderRadius: "8px",
            }}
          >
            <source src={itemLink} />
            Your browser does not support the video tag.
          </video>
        )}

        {isPdf && itemLink && (
          <iframe
            title={itemName || "PDF"}
            src={itemLink}
            style={{
              width: "100%",
              height: contentItems.length > 1 ? "400px" : "70vh",
              border: "none",
              borderRadius: "8px",
            }}
          />
        )}

        {isAudio && itemLink && !audioError && (
          <audio
            controls
            style={{ width: "100%", marginTop: "20px" }}
            onError={() => setAudioError(true)}
          >
            <source src={itemLink} />
            Your browser does not support the audio element.
          </audio>
        )}

        {isAudio && audioError && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>Unable to play audio. The file might not be accessible.</p>
            <a
              href={itemLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                borderRadius: "4px",
              }}
            >
              Download Audio File
            </a>
          </div>
        )}

        {isImage && itemLink && (
          <img
            src={itemLink}
            alt={itemName || "Image"}
            style={{
              maxWidth: "100%",
              maxHeight: contentItems.length > 1 ? "300px" : "70vh",
              borderRadius: "8px",
              objectFit: "contain",
            }}
            onError={() => setImageError(true)}
          />
        )}

        {isPpt &&
          itemLink &&
          (isBlobUrl ? (
            <iframe
              title={itemName || "Presentation"}
              src={itemLink}
              style={{
                width: "100%",
                height: contentItems.length > 1 ? "300px" : "70vh",
                border: "none",
                borderRadius: "8px",
              }}
              allowFullScreen
            />
          ) : drivePreviewUrl ? (
            <iframe
              title={itemName || "Presentation"}
              src={drivePreviewUrl}
              style={{
                width: "100%",
                height: contentItems.length > 1 ? "300px" : "70vh",
                border: "none",
                borderRadius: "8px",
              }}
              allowFullScreen
            />
          ) : (
            <div
              style={{
                height: contentItems.length > 1 ? "300px" : "70vh",
                width: "100%",
              }}
            >
              {pptViewer === "office" && (
                <iframe
                  title={itemName || "Presentation"}
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    itemLink,
                  )}`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  onError={() => setPptViewer("google")}
                />
              )}

              {pptViewer === "google" && (
                <iframe
                  title={itemName || "Presentation"}
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    itemLink,
                  )}&embedded=true`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  onError={() => setPptViewer("failed")}
                />
              )}
            </div>
          ))}

        {!itemLink && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 20px",
              textAlign: "center",
              minHeight: "200px",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#f8f9fa",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6c757d"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h4
              style={{
                color: "#495057",
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "8px",
                margin: 0,
              }}
            >
              No Content Available
            </h4>
            <p
              style={{
                color: "#6c757d",
                fontSize: "14px",
                marginBottom: "0",
              }}
            >
              No content URL configured for this material.
            </p>
          </div>
        )}

        {itemLink && item.id && (role === "admin" || ((role === "institution" || role === "teacher") && !pageData?.is_admin_page)) && (
          <div style={{ marginTop: "10px", textAlign: "right" }}>
            <button
              onClick={() => handleRemove(item.id)}
              disabled={isRemoving}
              style={{
                backgroundColor: "transparent",
                color: "#dc3545",
                border: "1px solid #dc3545",
                borderRadius: "4px",
                padding: "8px 16px",
                cursor: isRemoving ? "not-allowed" : "pointer",
                fontSize: "14px",
                transition: "all 0.2s",
              }}
              title="Remove content"
              onMouseOver={(e) => {
                if (!isRemoving) {
                  e.target.style.backgroundColor = "#dc3545";
                  e.target.style.color = "white";
                }
              }}
              onMouseOut={(e) => {
                if (!isRemoving) {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#dc3545";
                }
              }}
            >
              Remove
            </button>
          </div>
        )}
      </div>
    );
  };

  const hasContent =
    contentItems.length > 0 && contentItems.some((item) => item.link);

  return (
    <div
      className="material-viewer"
      style={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      {!hasContent ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            padding: "40px 20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "120px",
              backgroundColor: "#f8f9fa",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <svg
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
              <polyline points="13 2 13 9 20 9"></polyline>
            </svg>
          </div>
          <h3
            style={{
              color: "#495057",
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              margin: 0,
            }}
          >
            No Content Available
          </h3>
          <p
            style={{
              color: "#6c757d",
              fontSize: "14px",
              marginBottom: "0",
            }}
          >
            There are currently no materials to display. Upload materials to get
            started.
          </p>
        </div>
      ) : (
        <>
          {contentItems.length > 1 ? (
            <div
              className="multi-content-container custom-scrollbar"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {contentItems
                .sort((a, b) => a.sequence - b.sequence)
                .map((item, index) => renderContentItem(item, index))}
            </div>
          ) : contentItems.length === 1 ? (
            renderContentItem(contentItems[0], 0)
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                padding: "40px 20px",
                textAlign: "center",
                minHeight: "300px",
              }}
            >
              <div
                style={{
                  width: "120px",
                  height: "120px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#6c757d"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                  <polyline points="13 2 13 9 20 9"></polyline>
                </svg>
              </div>
              <h3
                style={{
                  color: "#495057",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  margin: 0,
                }}
              >
                No Content Available
              </h3>
              <p
                style={{
                  color: "#6c757d",
                  fontSize: "14px",
                  marginBottom: "0",
                }}
              >
                There are currently no materials to display. Upload materials to
                get started.
              </p>
            </div>
          )}
        </>
      )}

      {isConfirmDeleteOpen && (
        <DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmDeleteOpen}
          setIsConfirmDeleteOpen={setIsConfirmDeleteOpen}
          handleDelete={handleConfirmRemove}
          title="Remove Material"
          message="Are you sure you want to remove this material? This action cannot be undone."
          confirmLabel="Remove"
          cancelLabel="Cancel"
        />
      )}
    </div>
  );
};

export default MaterialViewer;
